import {Vue} from 'vue-property-decorator';
import {GenericTableSelectMode} from '../GenericTableSelectMode';
import {IRow} from '../GenericTableRow';

/** Stratégie pour un "GenericTable" avec une selection multiple */
export class GenericTableModeMultiSelect extends GenericTableSelectMode {

    /** Application concrète de l'initialisation des paramètres pour "selection multiple" */
    public Initialize(): void {
        Vue.set(this.context, 'EnableToggleSelectionAll', true);
        Vue.set(this.context, 'EnableMenuLeft', false);
        Vue.set(this.context, 'EnableSelectorCheckBox', true);
        Vue.set(this.context, 'EnableSelectorRow', false);
        Vue.set(this.context, 'ShowSelectedCount', true);
    }

    /**
     * Permute l'état de selection de toutes les lignes
     * @param row Lignes dont l’état de sélection doit être inversé
     */
    public ToggleRow(row: IRow, displayedRows: boolean = true): void {
        /** Si sélection verrouillée alors annulation le toggle */
        if (row.IsLockedSelect)
            return;

        if (!row.Selected) {
            /** Si non "selected" alors on le sélectionne */
            this.context.SelectedRows.push(row);
            if (displayedRows)
                this.context.SelectedDisplayedRows.push(row);
            Vue.set(row, 'Selected', true);
        } else {
            /** Si "selected" alors on le désélectionne */

            /** Retrait de la liste des sélectionnées */
            const indexSelected = this.context.SelectedRows.indexOf(row)
            if (indexSelected > -1)
                this.context.SelectedRows.splice(indexSelected, 1);
            /** Retrait de la liste des sélectionnées affichées */
            const indexDisplayed = this.context.SelectedDisplayedRows.indexOf(row)
            if (indexDisplayed > -1)
                this.context.SelectedDisplayedRows.splice(indexDisplayed, 1);
            Vue.set(row, 'Selected', false);
        }
    }

    /**
     * Permute l'état de selection de toute les lignes
     * @param rows Liste des lignes dont l’état de sélection doit être inversé
     */
    public ToggleRows(): void {
        this.toggleRows(this.context.FilteredRows, false);
    }

    /**
     * Permute l'état de selection de toute les lignes affichés sur la page en cours
     * @param rows Liste des lignes dont l’état de sélection doit être inversé
     */
    public ToggleDisplayedRows(): void {
        this.toggleRows(this.context.DisplayedRows, true);
    }

    /**
     * Permute l'état de sélection de toutes les lignes.
     * @param rows Ensemble de ligne à permuter
     * @param isDisplayed indique si les lignes sont affichées
     */
    private toggleRows(rows: IRow[], isDisplayed: boolean) {
        /** Détermine si toutes les lignes sont sélectionnées */
        let allSelected = !rows.some(row => !row.IsLockedSelect && !row.Selected);

        if (allSelected) {
            this.context.SelectedRows.splice(0, this.context.SelectedRows.length);
            this.context.SelectedDisplayedRows.splice(0, this.context.SelectedDisplayedRows.length);
            rows.forEach(row => {
                Vue.set(row, 'Selected', false);
            });
        } else
            this.selectRows(rows, isDisplayed);
    }

    /**
     * Sectionne une liste de ligne.
     * @param rows Liste de lignes à sélectionner.
     */
    private selectRows(rows: IRow[], displayedRows: boolean): void {
        rows.forEach(row => {
            if (!row.IsLockedSelect && !row.Selected) {
                Vue.set(row, 'Selected', true);
                this.context.SelectedRows.push(row);
                if (displayedRows)
                    this.context.SelectedDisplayedRows.push(row)
            }
        });
    }
}